// "What's my size?" popup.
// The trigger link sits inside the Vue-rendered product options, which Vue
// re-creates after this file runs, so a listener bound directly to the link was
// lost and the popup never opened. Listen on the document instead, which keeps
// working however often Vue redraws the link.
(function () {
  function closeAll() {
    document.querySelectorAll('.popup-modal.is--visible').forEach(function (m) { m.classList.remove('is--visible'); });
    var blackout = document.querySelector('.body-blackout');
    if (blackout) blackout.classList.remove('is-blacked-out');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.popup-trigger[data-popup-trigger]');
    if (trigger) {
      e.preventDefault();
      var modal = document.querySelector('[data-popup-modal="' + trigger.dataset.popupTrigger + '"]');
      if (!modal) return;
      modal.classList.add('is--visible');
      var blackout = document.querySelector('.body-blackout');
      if (blackout) blackout.classList.add('is-blacked-out');
      return;
    }
    if (e.target.closest('.popup-modal__close') || e.target.closest('.body-blackout')) closeAll();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Opening a product link that ends in #size-chart shows the chart straight away
  if (location.hash === '#size-chart') {
    document.addEventListener('DOMContentLoaded', function () {
      var modal = document.querySelector('[data-popup-modal="one"]');
      if (modal) {
        modal.classList.add('is--visible');
        var blackout = document.querySelector('.body-blackout');
        if (blackout) blackout.classList.add('is-blacked-out');
      }
    });
  }
})();
